import { Button, Typography } from '@material-tailwind/react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Container from '../components/Container'
import Divider from '../components/Divider'
import { usePageTitle } from '../hooks/toolkit'
import illustration from '../assets/png/how-it-works/how_it_works_illustr.png'
import step1 from '../assets/png/how-it-works/step-1.png'
import step2 from '../assets/png/how-it-works/step-2.png'
import step3 from '../assets/png/how-it-works/step-3.png'
import { useAgamiRoutes } from '../hooks/useAgamiRoutes'

const HowItWorks = () => {
  const { t } = useTranslation()
  usePageTitle('How it works | Agami')

  const navigate = useNavigate()
  const { newAgamiPath } = useAgamiRoutes()

  return (
    <Container direction="col" className="text-primary dark:text-base-gray-400">
      <div className="flex text-center flex-col justify-center items-center gap-4 py-4 lg:py-10 px-2 lg:px-32">
        <img className="w-1/2 lg:w-1/3" src={illustration} alt="how agami works?" title="how agami works?" />

        <Typography variant="h1">{t('howItWorks.title')}</Typography>

        <Typography>{t('howItWorks.description')}</Typography>

        <Typography variant="h5">
          <strong>{t('howItWorks.subtitle')}</strong>
        </Typography>
      </div>

      <Divider color="dark" />

      <div className="grid grid-cols-2 gap-8 py-4 lg:py-10">
        <div className="flex flex-col gap-4 col-span-2 lg:col-span-1 items-center lg:items-start">
          <Typography variant="h2">{t('howItWorks.uploadAgami.title')}</Typography>

          <img
            src={step1}
            className="block lg:hidden w-full border rounded shadow col-span-2 lg:col-span-1"
            title="upload an agami"
            alt="upload an agami"
          />

          <Typography>{t('howItWorks.uploadAgami.description')}</Typography>

          <Typography>
            <ul className="pl-8 list-disc">
              <li>
                <strong>{t('upload.spotName')}</strong> {t('howItWorks.uploadAgami.name')}
              </li>
              <li>
                <strong>{t('upload.description')}</strong> {t('howItWorks.uploadAgami.descriptionFieldText')}
              </li>
              <li>
                <strong>{t('howItWorks.uploadAgami.gpsCoordinates')}</strong>
              </li>
              <li>
                <strong>{t('howItWorks.uploadAgami.radius')}</strong>
              </li>
            </ul>
          </Typography>

          <Typography>
            <strong>{t('howItWorks.uploadAgami.confirm')}</strong>
          </Typography>

          <Button size="sm" onClick={() => navigate(newAgamiPath())}>
            {t('howItWorks.uploadAgami.tryButton')}
          </Button>
        </div>

        <img
          src={step1}
          className="hidden lg:block w-full border rounded shadow col-span-2 lg:col-span-1"
          title="upload an agami"
          alt="upload an agami"
        />
      </div>

      <Divider color="dark" />

      <div className="grid grid-cols-2 gap-8 py-4 lg:py-10 justify-center">
        <img
          src={step2}
          className="hidden lg:block w-1/2 justify-self-center col-span-2 lg:col-span-1"
          title="explore agami map"
          alt="explore agami map"
        />

        <div className="flex flex-col gap-4 col-span-2 lg:col-span-1 items-center lg:items-start">
          <Typography variant="h2">{t('howItWorks.exploreAgami.title')}</Typography>

          <img
            src={step2}
            className="block lg:hidden w-1/2 justify-self-center col-span-2 lg:col-span-1"
            title="explore agami map"
            alt="explore agami map"
          />

          <Typography>{t('howItWorks.exploreAgami.description')}</Typography>

          <Typography>{t('howItWorks.exploreAgami.enjoy')}</Typography>

          <Button size="sm" onClick={() => navigate('/experience/679ec009-b360-40c3-bf21-ed49e4a7789c')}>
            {t('howItWorks.exploreAgami.exploreButton')}
          </Button>
        </div>
      </div>

      <Divider color="dark" />

      <div className="grid grid-cols-2 gap-8 py-4 lg:py-10 justify-center mb-8">
        <div className="flex flex-col gap-4 col-span-2 lg:col-span-1 items-center lg:items-start">
          <Typography variant="h2">{t('howItWorks.simulateLocation.title')}</Typography>

          <img
            src={step3}
            className="block lg:hidden w-full border rounded shadow col-span-2 lg:col-span-1"
            title="simulate position"
            alt="simulate position"
          />

          <Typography>{t('howItWorks.simulateLocation.description')}</Typography>

          <Typography>{t('howItWorks.simulateLocation.enjoy')}</Typography>

          <Button size="sm" onClick={() => navigate('/experience/679ec009-b360-40c3-bf21-ed49e4a7789c')}>
            {t('howItWorks.simulateLocation.exploreButton')}
          </Button>
        </div>

        <img
          src={step3}
          className="hidden lg:block  w-full border rounded shadow col-span-2 lg:col-span-1"
          title="simulate position"
          alt="simulate position"
        />
      </div>
    </Container>
  )
}

export default HowItWorks
